var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 11.458,
    viewBox: "0 0 20 11.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.025,11.458A11.965,11.965,0,0,1,3.057,8.981,13.746,13.746,0,0,1,.425,6.5L.219,6.245a.785.785,0,0,1,0-1.032l.206-.258A15.661,15.661,0,0,1,3.057,2.477,11.965,11.965,0,0,1,10.025,0a11.965,11.965,0,0,1,6.968,2.477,13.746,13.746,0,0,1,2.632,2.477l.206.258a.785.785,0,0,1,0,1.032l-.206.31a15.867,15.867,0,0,1-2.632,2.477A12.013,12.013,0,0,1,10.025,11.458ZM.838,5.729l.206.31A13.855,13.855,0,0,0,3.522,8.361a11.109,11.109,0,0,0,6.452,2.323,10.764,10.764,0,0,0,6.452-2.323A12.17,12.17,0,0,0,18.9,6.039l.206-.258L18.9,5.523A13.855,13.855,0,0,0,16.425,3.2,11.109,11.109,0,0,0,9.973.877,10.764,10.764,0,0,0,3.522,3.2,11.953,11.953,0,0,0,1.044,5.523Z",
    transform: "translate(-0.025)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.626,3.4a4.026,4.026,0,1,0,4.026,4.026A4.031,4.031,0,0,0,15.626,3.4Zm.1,2.168a.469.469,0,0,1-.361.155,1.443,1.443,0,0,0-1.445,1.445.517.517,0,0,1-.516.516.488.488,0,0,1-.516-.516A2.478,2.478,0,0,1,15.368,4.69a.517.517,0,0,1,.516.516A.469.469,0,0,1,15.729,5.568Z",
    transform: "translate(-5.626 -1.645)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.f2b7d6ca18657ecea16ccf1691b2a575.svg";
export { ForwardRef as ReactComponent };